import { Component, Input } from '@angular/core';
import { WorkshopJobService } from '../services/workshop-job.service';
import { ConfigService } from '../services/config.service';
import { mergeMap, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { BehaviorSubject, iif, of } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AddWorkshopItemDialogComponent } from '../dialogs/add-workshop-item-dialog/add-workshop-item-dialog.component';
import { WorkshopJob } from '../../models/workshop-job';
import { MomentModule } from 'ngx-moment';
import { HlCurrencyPipe } from '../pipes/hl-currency.pipe';
import { WorkshopJobStatusLabelPipe } from '../pipes/workshop-job-status-label.pipe';
import { MatButton } from '@angular/material/button';
import {
  MatTable,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell
} from '@angular/material/table';
import { NgIf, AsyncPipe, TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-workshop-job-history-list',
  templateUrl: './workshop-job-history-list.component.html',
  standalone: true,
  imports: [
    NgIf,
    MatTable,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatButton,
    AsyncPipe,
    TitleCasePipe,
    WorkshopJobStatusLabelPipe,
    HlCurrencyPipe,
    MomentModule
  ]
})
export class WorkshopJobHistoryListComponent {
  columns = [
    'id',
    'type',
    'booked_in_at',
    'work_status',
    'labour',
    'total_cost'
  ];

  @Input() set data(data: { type: 'item' | 'customerEquipment'; id: number }) {
    this.type = data.type;
    this.id = data.id;
    this.currentData.next(data);
  }

  @Input() dialogRef: MatDialogRef<any>;

  dateFormat = ConfigService.dates.longDateTimeFormat;

  private currentData = new BehaviorSubject<any>(null);
  private type: 'item' | 'customerEquipment';
  private id: number;

  noHistory = false;
  rows$ = this.currentData.pipe(
    mergeMap((data) =>
      iif(
        () => !data,
        of([]),
        this.workshopJobService.getHistory(data.type, data.id)
      )
    ),
    tap((rows) => (this.noHistory = rows.length === 0))
  );

  constructor(
    private workshopJobService: WorkshopJobService,
    private dialog: MatDialog,
    private configService: ConfigService,
    private router: Router
  ) {}

  viewJob(id: number) {
    this.router.navigate(['workshop', 'job', id]);
    this.dialogRef.close();
  }

  addWorkshopJob() {
    this.dialog.open(AddWorkshopItemDialogComponent, {
      data: {
        repairable_type: this.type,
        repairable_id: this.id,
        name: 'Item',
        onSubmit: (job, close) => {
          this.workshopJobService
            .addWorkshopJob(job)
            .subscribe((job: WorkshopJob<any>) => {
              close();
              this.dialogRef.close();
              this.router.navigate(['/workshop/job/', job.id]);
            });
        }
      }
    });
  }
}
